export const environment = {
    production: false,
    name: 'development',
    modul: 'bildverifizierung',
    bildverifizierungUrl: 'https://bildverifizierung-development.algo-esg.app',
    sse_environment: 'https://zutrittsereignisse-development.algo-esg.app',
    keycloak: {
        realm: 'development',
        url: 'https://identity.algo-esg.app',
        clientId: 'algoShellBildverifizierung',
    },
};
